import { Reveal } from "./Reveal";
import { useT } from "@/i18n";

export const Services = () => {
  const t = useT().services;

  return (
    <section id="services" className="mx-auto max-w-[1440px] px-6 py-28 lg:px-12 lg:py-40" data-testid="services-section">
      <Reveal>
        <p className="mb-4 text-[11px] uppercase tracking-[0.35em] text-terra" data-testid="services-kicker">{t.kicker}</p>
        <h2 className="max-w-2xl font-serif text-4xl tracking-tight sm:text-5xl" data-testid="services-heading">
          {t.headingA} <em className="italic text-terra">{t.headingEm}</em>
        </h2>
        <p className="mt-6 max-w-xl text-base text-smoke md:text-lg" data-testid="services-subtext">
          {t.subtext}
        </p>
      </Reveal>

      <div className="mt-20 border-t border-ink/15">
        {t.items.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.06}>
            <div
              className="group grid grid-cols-12 items-baseline gap-4 border-b border-ink/15 py-10 transition-colors duration-500 hover:bg-sand/60 lg:py-12"
              data-testid={`service-item-${s.n}`}
            >
              <span className="col-span-2 font-serif text-3xl italic text-ink/25 transition-colors duration-500 group-hover:text-terra lg:col-span-1 lg:text-4xl">
                {s.n}
              </span>
              <h3 className="col-span-10 font-serif text-2xl tracking-tight sm:text-3xl lg:col-span-4">
                {s.title}
              </h3>
              <p className="col-span-10 col-start-3 mt-3 text-sm leading-relaxed text-smoke lg:col-span-6 lg:col-start-7 lg:mt-0 lg:text-base">
                {s.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
